import $ from 'jquery';

function submitClosestForm(e) {
  const $link = $(e.currentTarget);
  const $form = $link.closest('form');
  $form.submit();
}

$(document).on('click', '.js-form-post', submitClosestForm);
